<template>
  <div>
    <div style="margin-bottom: 20px">
      <el-button @click="back" type="danger" style="margin-right: 10px" icon="el-icon-back"></el-button>
      <el-date-picker
          v-model="choiceDate"
          type="month" value-format="yyyy-MM"
          placeholder="请选择日期"
      />
      <el-cascader collapse-tags style="width: 210px;margin: 0 10px" ref="cascaderRef" placeholder="请选择人员"
                   :options="deptUserTree" v-model="choiceUser"
                   :props="{ multiple: true,label:'name',value:'id'}"></el-cascader>
      <el-select v-model="tableQuery.groupIdList" filterable placeholder="请选择考勤组" multiple  collapse-tags style="margin-right: 10px">
        <el-option v-for="item in attendanceGroup" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-button :loading="tableQuery.tableLoading" type="danger" @click="selectTable">搜 索</el-button>
      <el-button type="danger" @click="exportFile">导 出</el-button>
    </div>
    <el-table :data="tableData.resultMap" class="table" height="615px" border v-loading="tableQuery.tableLoading">
      <el-table-column prop="coachName" show-overflow-tooltip label="姓名" width="100"/>
      <el-table-column prop="deptName" show-overflow-tooltip label="部门" width="180"/>
      <el-table-column prop="groupName" show-overflow-tooltip label="考勤组" width="200"/>
      <el-table-column label="总休" width="80" min-width="200" align="center">
        <template #default="scope">
          {{scope.row.restDayCount}}天
        </template>
      </el-table-column>
      <el-table-column label="旷工" width="80" min-width="200" align="center">
        <template #default="scope">
          {{scope.row.absenteeCount}}次
        </template>
      </el-table-column>
      <el-table-column label="迟到" width="80" min-width="200" align="center">
        <template #default="scope">
          {{scope.row.beLateCount}}次
        </template>
      </el-table-column>
      <el-table-column label="早退" width="80" min-width="200" align="center">
        <template #default="scope">
          {{scope.row.leaveEarlyCount}}次
        </template>
      </el-table-column>
      <el-table-column label="上班缺卡" width="90" min-width="200" align="center">
        <template #default="scope">
          {{scope.row.toMissingCardCount}}次
        </template>
      </el-table-column>
      <el-table-column label="下班缺卡" width="90" min-width="200" align="center">
        <template #default="scope">
          {{scope.row.offMissingCardCount}}次
        </template>
      </el-table-column>
      <el-table-column label="外出" width="80" min-width="200" align="center">
        <template #default="scope">
          {{scope.row.goOutWorkCount}}小时
        </template>
      </el-table-column>
      <el-table-column label="出差" width="80" min-width="200" align="center">
        <template #default="scope">
          {{scope.row.travelFrequency}}小时
        </template>
      </el-table-column>
      <el-table-column label="出勤" width="80" min-width="200" align="center">
        <template #default="scope">
          {{scope.row.workDayCount}}天
        </template>
      </el-table-column>
      <el-table-column label="应出勤" width="80" min-width="200" align="center">
        <template #default="scope">
          {{scope.row.shouldGoDay}}天
        </template>
      </el-table-column>
      <el-table-column label="补卡次数" width="80" min-width="200" align="center">
        <template #default="scope">
          {{scope.row.repCount}}次
        </template>
      </el-table-column>
      <el-table-column label="工作时长" width="80" min-width="200" align="center">
        <template #default="scope">
          {{scope.row.workTime}}分钟
        </template>
      </el-table-column>
      <el-table-column label="考勤确认" width="80" min-width="200" align="center">
        <template #default="scope">
          {{scope.row.monthSure == 0 ? '未确认':'已确认'}}
        </template>
      </el-table-column>
      <el-table-column align="center" v-for="(item, index) in tableData.groupDateMap" :key="index" width="120">
        <template #header>
              <div style="font-weight: normal;color: #000000">
                <div style="font-weight: bold;">{{ item.day }}</div>
                <div style="color: #606266;font-size: 12px"
                     :style="(item.dayOfWeek == '六' || item.dayOfWeek == '日' ? 'color:red':'')">
                  <span style="margin-right: 2px">周</span>{{ item.dayOfWeek }}
                </div>
              </div>
        </template>
        <template #default="scope">
<!--          <el-tooltip class="item" effect="dark" placement="top">-->
<!--            <div slot="content">{{scope.row.clockInAll[index].clockInStr}}</div>-->
            <div @click="selectItemDefault(scope.row,index)">{{scope.row.clockInAll[index].clockInStr}}</div>
<!--          </el-tooltip>-->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        style="text-align: right;margin: 20px 10px"
        :page-sizes="[100, 200, 300, 400]"
        :page-size="tableQuery.pageSize"
        @current-change="changePage"
        layout="total, prev, pager, next, jumper"
        :total="tableQuery.tableTotal">
    </el-pagination>
    <el-dialog
        :title="titleName()"
        width="1000px"
        :visible.sync="itemDefaultDialog">
      <div style="margin:0 20px" v-if="itemDefaultIndex!=null">
        <el-descriptions class="margin-top" :column="1">
          <el-descriptions-item>
            <template slot="label">姓名</template>
            {{itemDefault.coachName}}
          </el-descriptions-item>
        </el-descriptions>
        <el-descriptions class="margin-top" :column="2">
          <el-descriptions-item>
            <template slot="label">部门</template>
            {{itemDefault.deptName}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">考勤组</template>{{itemDefault.groupName}}
          </el-descriptions-item>
        </el-descriptions>
        <div v-if="itemDefault.clockInAll[itemDefaultIndex].passApplicationList != null">
          <el-table size="mini" class="table" style="width: 100%;margin-bottom: 20px" border height="150px"
                    :data="itemDefault.clockInAll[itemDefaultIndex].passApplicationList" >
            <el-table-column label="申请类型">
              <template #default="scope">
                {{scope.row.beiZhu}}申请
              </template>
            </el-table-column>
            <el-table-column prop="startTime" label="开始时间">
            </el-table-column>
            <el-table-column prop="endTime" label="结束日期">
            </el-table-column>
          </el-table>
        </div>



        <div style="display: flex">
          <el-table :cell-style="{ padding: '0' }" border style="width: 100%;border-radius: 10px 0 0 10px"
              :data="itemDefault.clockInAll[itemDefaultIndex].workClasses.classesDetails">
            <el-table-column prop="toTime" label="考勤时间" width="90" align="center">
            </el-table-column>
            <el-table-column prop="clockToTime" width="90" align="center" label="打卡时间">
            </el-table-column>
            <el-table-column width="90" align="center" label="打卡详情">
              <template #default="scope">
                <el-popover placement="top" width="200" trigger="hover">
                  <div v-if="scope.row.toClockMethod!=null">
                    <div>蓝牙：{{ scope.row.toClockMethod.bluetoothName }}</div>
                    <div>WIFI：{{ scope.row.toClockMethod.wifiName }}</div>
                    <div>纬度：{{ scope.row.toClockMethod.latitude }}</div>
                    <div>经度：{{ scope.row.toClockMethod.longitude }}</div>
                  </div>
                  <template #reference>
                    <div style="height: 50px;border-radius: 6px;display: flex;align-items: center;justify-content: center">
                      <el-image v-if=" scope.row.toClockMethod && scope.row.toClockMethod.imageUrl!=null"
                                style="width: 40px; height: 40px;border-radius: 6px"
                                :src="scope.row.toClockMethod.imageUrl"
                                :preview-src-list="[scope.row.toClockMethod.imageUrl]">
                      </el-image>
                    </div>
                  </template>
                </el-popover>

              </template>
            </el-table-column>
            <el-table-column label="打卡结果" align="center">
              <template #default="scope">
                <div style="display:flex;justify-content: center">
                  <div v-if="scope.row.toType!=null">
                    <div v-if="scope.row.toType == 0">正常</div>
                    <div v-if="scope.row.toType == 1">迟到</div>
                    <div v-if="scope.row.toType == 2">早退</div>
                    <div v-if="scope.row.toType == 3">缺卡</div>
                  </div>
                  <div v-else>
                    <div v-if="itemDefault.clockInAll[itemDefaultIndex].workClasses.id > 0">
                      缺卡
                    </div>
                  </div>
                  <div v-if="scope.row.toOutWorkClock!=null">
                    <span> - </span>
                    <span>外勤</span>
                    <span v-if="scope.row.toOutWorkClock.state == 0" style="color: red">未生效</span>
                  </div>
                </div>
              </template>
            </el-table-column>

          </el-table>
          <el-table :header-row-style="{ height: '10px !important' }" :cell-style="{ padding: '0' }"
              :data="itemDefault.clockInAll[itemDefaultIndex].workClasses.classesDetails"
              border
              style="width: 100%;border-radius:0 10px 10px 0">
            <el-table-column prop="offTime" label="考勤时间" width="90" align="center">
            </el-table-column>
            <el-table-column width="90" align="center"
                prop="clockOffTime"
                label="打卡时间">
            </el-table-column>
            <el-table-column label="打卡详情" width="90" align="center">
              <template #default="scope">
                <el-popover placement="top" width="200" trigger="hover">
                  <div v-if="scope.row.offClockMethod!=null">
                    <div>蓝牙：{{ scope.row.offClockMethod.bluetoothName }}</div>
                    <div>WIFI：{{ scope.row.offClockMethod.wifiName }}</div>
                    <div>纬度：{{ scope.row.offClockMethod.latitude }}</div>
                    <div>经度：{{ scope.row.offClockMethod.longitude }}</div>
                  </div>
                  <template #reference>
                    <div  style="height: 50px;border-radius: 6px;display: flex;align-items: center;justify-content: center">
                      <el-image v-if="scope.row.offClockMethod && scope.row.offClockMethod.imageUrl"
                                style="width: 40px; height: 40px;border-radius: 6px"
                                :src="scope.row.offClockMethod.imageUrl"
                                :preview-src-list="[scope.row.offClockMethod.imageUrl]">
                      </el-image>
                    </div>
                  </template>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column align="center" label="打卡结果">
              <template #default="scope">
                <div style="display: flex;justify-content: center">
                  <div v-if="scope.row.offType!=null">
                    <div v-if="scope.row.offType == 0">正常</div>
                    <div v-if="scope.row.offType == 1">迟到</div>
                    <div v-if="scope.row.offType == 2">早退</div>
                    <div v-if="scope.row.offType == 3">缺卡</div>
                  </div>
                  <div v-else>
                    <div v-if="itemDefault.clockInAll[itemDefaultIndex].workClasses.id > 0">
                      缺卡
                    </div>
                  </div>
                  <div v-if="scope.row.offOutWorkClock!=null">
                    <span> - </span>
                    <span>外勤</span>
                    <span v-if="scope.row.offOutWorkClock.state == 0" style="color: red">未生效</span>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {selectStatisticsData,exportStatistics} from '/src/api/attendance/statistics'
import {selectAllAttendanceGroup} from '/src/api/attendance/attendanceGroup'
import {selectDeptAndUserTree} from "../../../../../api/contacts/dept";
export default {
  name: "StatementDetail",
  data() {
    return {
      item:{},
      itemDefault:null,
      itemDefaultIndex:null,
      itemDefaultDialog:false,
      choiceDate:null,
      deptUserTree:[],
      attendanceGroup:[],
      choiceUser:[],
      tableData:[],
      tableQuery:{
        tableTotal:0,
        tableLoading:false,
        coachIdList: [],
        groupIdList: [],
        month: null,
        pageIndex: 0,
        pageSize: 11,
        year: null
      },
    }
  },
  methods:{
    titleName(){
      if (this.itemDefault == null || this.itemDefaultIndex == null){
        return "";
      }
      return this.itemDefault.coachName+' '+
      this.tableQuery.year+'-'+
      this.tableQuery.month+'-'+
      this.tableData.groupDateMap[this.itemDefaultIndex].day+' 周'+
      this.tableData.groupDateMap[this.itemDefaultIndex].dayOfWeek;
    },
    nameDispose(name) {
      return  name.length > 2 ? name.slice(0,2):name
    },
    selectItemDefault(item,index){
      this.itemDefault = item;
      this.itemDefaultIndex = index;
      this.itemDefaultDialog = true;
    },

    changePage(index){
      this.tableQuery.pageIndex = index;
      this.selectTable();
    },
    exportFile(){
      if (this.choiceDate){
        const parts = this.choiceDate.split('-');
        this.tableQuery.year = parts[0];
        this.tableQuery.month = parts[1];
      }
      this.changePeople();
      this.tableQuery.tableLoading = true;
      exportStatistics(this.tableQuery).then(val=>{
        this.tableQuery.tableLoading = false;
        if (val.status == 200){
          let url = val.data;
          window.URL = window.URL || window.webkitURL;
          var name = url.substring(url.lastIndexOf("/") + 1, url.length);
          var xhr = new XMLHttpRequest();
          var a = document.createElement("a");
          xhr.open("GET", url, true);
          xhr.responseType = "blob";
          xhr.onload = function() {
            var file = new Blob([xhr.response], { type: "application/octet-stream" });
            a.href = window.URL.createObjectURL(file);
            a.download = name;
            a.click();
          };
          xhr.send();
        }
      })
    },
    selectTable(){
      if (this.choiceDate){
        const parts = this.choiceDate.split('-');
        this.tableQuery.year = parts[0];
        this.tableQuery.month = parts[1];
      }
      this.changePeople();
      this.tableQuery.tableLoading = true;
      selectStatisticsData(this.tableQuery).then(val=>{
        this.tableQuery.tableLoading = false;
        if (val.status == 200){
          this.tableData = val.data;
          this.tableQuery.tableTotal = val.data.total;
        }
      })
    },
    changePeople(){
      let list = [];
      const ref = this.$refs.cascaderRef;
      if (ref){
        const checkedNodes = ref.getCheckedNodes();
        checkedNodes.forEach((node) => {
          if (node.data.type == 1){//只保留用户不保留部门
            list.push(node.value)
          }
        });
        this.tableQuery.coachIdList = list;
      }
    },
    back(){
      this.$router.back();
    },
    setDefaultData(){
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      this.choiceDate = year+'-'+month;
      this.tableQuery.year = year;
      this.tableQuery.month = month;
      let query = this.$route.query;
      this.item = query.item;
    }
  },
  created() {
    this.setDefaultData();
    this.selectTable();
    selectDeptAndUserTree().then(val=>{
      if (val.status == 200){
        this.deptUserTree=val.data;
      }
    })
    selectAllAttendanceGroup().then(val=>{
      if (val.status == 200){
        this.attendanceGroup=val.data;
      }
    })
  }
}
</script>

<style scoped>
.table{
  width: 100%;
  border-radius: 10px;
  padding: 6px 0px 10px 6px;
}
::v-deep .el-cascader__tags{
  width: 68%;
  flex-wrap: nowrap;
}
</style>